import { render, staticRenderFns } from "./UiClock.vue?vue&type=template&id=35cb38d0&scoped=true&"
import script from "./UiClock.vue?vue&type=script&lang=js&"
export * from "./UiClock.vue?vue&type=script&lang=js&"
import style0 from "./UiClock.vue?vue&type=style&index=0&id=35cb38d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb38d0",
  null
  
)

export default component.exports